const QuotationHeader = () => {
    return (
        <div>
            <h1 className="text-2xl font-semibold text-gray-800">Báo Giá Dịch Vụ</h1>
        </div>
    );
};

export default QuotationHeader;